import { render } from "./ModalCheckDuplicateOrder.vue?vue&type=template&id=4c1df807"
import script from "./ModalCheckDuplicateOrder.vue?vue&type=script&lang=js"
export * from "./ModalCheckDuplicateOrder.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__